import {init} from './Pages/Common';
import {ready} from './Helpers/Helper.js';
import {initHeroSlider} from './Blocks/HeroSlider.js';
import {initLoadMore} from './Blocks/LoadMore';

ready(
    () => {
        init();
        initLoadMore();
        initHeroSlider();
    },
);
